module.exports = new __parcel__URL__("cancelButton.8f7500f1.png").toString();